import {
  Component,
  computed,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css'],
})
export class SideMenuComponent implements OnChanges {
  @Input() isLoggedIn: boolean;
  @Input() isGuest: boolean;
  @Output() menuEvent: EventEmitter<string> = new EventEmitter<string>();

  // Reactive role state
  @Input() role: string;
  currentRole = signal<string>('');
  loggedIn = signal<boolean>(false);


  isAdmin = computed(() => {
    const r = this.currentRole();
    return r === 'admin';
  });

  isClerk = computed(() => {
    const r = this.currentRole();
    return ['admin', 'clerk'].includes(r);
  });

  isWorker = computed(() => {
    const r = this.currentRole();
    return ['admin', 'clerk', 'worker'].includes(r);
  });


  deactivateAccount(): void {
    this.menuEvent.emit('deactivate');
  }
  openLoginDialog(): void {
    this.menuEvent.emit('login');
  }
  logOut(): void {
    this.menuEvent.emit('logout');
  }
  toggleDialog(): void {
    this.menuEvent.emit('toogle');
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.role) {
      this.role = changes.role.currentValue;
      this.currentRole.set(this.role);
    }

    if (changes.isLoggedIn) {
      this.isLoggedIn = changes.isLoggedIn.currentValue;
      this.loggedIn.set(this.isLoggedIn);
    }
  }
  ngOnInit(): void {
    /*
    this.userStatusSub = this.authService
      .getUser()
      .pipe(
        switchMap((user) => {
          this.userStatus.isLoggedIn = user ? true : false;
          return this.checkoutService.getItems();
        })
      )
      .subscribe((checkoutItems) => {
        this.userStatus.checkoutCount =
          this.checkoutService.calcTotalItems(checkoutItems);
      });
      */
  }

  ngOnDestroy(): void { }
}
